import { render, staticRenderFns } from "./JobDetailsCard.htm?vue&type=template&id=2d67ed6e&scoped=true&"
import script from "./JobDetailsCard.ts?vue&type=script&lang=js&"
export * from "./JobDetailsCard.ts?vue&type=script&lang=js&"
import style0 from "./JobDetailsCard.scss?vue&type=style&index=0&id=2d67ed6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d67ed6e",
  null
  
)

export default component.exports